import { Button, createStyles, makeStyles, Theme } from "@material-ui/core";
import { useState } from "react";
import { Alert } from "@material-ui/lab";
import TermsOfServiceAcceptance from "../../../components/Authentication/RegistrationSteps/Shared/TermsOfServiceAcceptance";
import { ITermsOfServiceFormValues } from "../_interfaces/ITermsOfServiceFormValues";
import FormLoadingSpinner from "../../../components/Organization/VolunteerOpportunities/FormLoadingSpinner";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        termsOfService: {
            color: theme.palette.text.secondary,
            margin: theme.spacing(2)
        },
        alert: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
            flexGrow: 1,
        },
    }),
);

interface TermsOfServiceFormProps {
    values: ITermsOfServiceFormValues;
    onChange: (patch: Partial<ITermsOfServiceFormValues>) => void;
    onSubmit: (overrideValues?: Partial<ITermsOfServiceFormValues>) => void;
    isSubmitting?: boolean;
    error?: string;
    fieldErrors?: Partial<Record<keyof ITermsOfServiceFormValues, string>>;
}

export const TermsOfServiceForm: React.FC<TermsOfServiceFormProps> = ({
    values,
    onChange,
    onSubmit,
    isSubmitting,
    error,
    fieldErrors
}) => {

    /********** State **********/

    const getFormId = () => {
        return `form-terms-of-service-${Date.now()}-${Math.random()}`;
    }

    const [formId] = useState(() => getFormId());

    /********** React hooks **********/

    const classes = useStyles();

    /********** Event handlers **********/

    const onSubmitButtonClicked = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault(); // Prevent page reload
        event.stopPropagation();
        onSubmit();
    }

    const termsOfServiceError = fieldErrors?.termsOfServiceAccepted;

    /********** Render **********/

    return (
        <form onSubmit={onSubmitButtonClicked} noValidate autoComplete="off" id={formId}>
            {values.loading ? <FormLoadingSpinner /> : undefined}
            {error && <Alert severity="error" className={classes.alert}>{error}</Alert>}
            <div className={classes.termsOfService}>
                <TermsOfServiceAcceptance
                    checked={values.termsOfServiceAccepted}
                    onChange={(accepted) => {
                        const patch = { termsOfServiceAccepted: accepted };
                        onChange(patch);
                    }}
                    error={termsOfServiceError && termsOfServiceError.length > 0 ? termsOfServiceError : undefined}
                    organizationTerms
                    disabled={isSubmitting}
                />
            </div>
            <Button color="primary" variant="contained" type="submit" form={formId} size="large" disabled={isSubmitting}>
                {values.buttonText}
            </Button>
        </form>
    );
};
